<ng-container *transloco="let t; prefix: 'scDeviceLicense.license-warning'">
	<ng-container
		*ngTemplateOutlet="
			deviceLicense.state === deviceLicenseStateEnum.GracePeriod ? warningTemplateRef : errorTemplateRef;
			context: {
				message: t('info', {
					title: deviceLicense.state | licenseStateTitlePipe,
					description: deviceLicense | licenseStateDescriptionPipe
				})
			}
		"
	></ng-container>
</ng-container>
